<template>
    <div class="form-field-checkbox flex flex-col space-y-3">
        <div v-if="title" class="text-md block font-medium leading-6 text-gray-900">
            {{ title }}
        </div>
        <div class="flex flex-row space-x-3 items-center">
            <input
                type="checkbox"
                :class="inputClasses"
                :name="id"
                :id="id"
                v-model="checkbox"
                @input="
                    (event) => {
                        $emit('update', {field, value: !!event.target.value, event});
                    }
                "
            />
            <label :for="id" class="cursor-pointer" :class="labelClasses" v-if="label">
                {{ label }}
            </label>
        </div>
        <div v-if="info" class="text-sm italic text-zinc-400">
            {{ info }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormFieldCheckbox',
    props: {
        id: {
            required: false,
            type: String,
            default: null,
        },
        title: {
            required: false,
            type: String,
            default: null,
        },
        label: {
            required: false,
            type: String,
            default: null,
        },
        info: {
            required: false,
            type: String,
            default: null,
        },
        field: {
            required: false,
            type: String,
            default: null,
        },
        value: {
            required: false,
            type: [Boolean, Number],
            default: null,
        },
        placeholder: {
            required: false,
            type: String,
            default: null,
        },
        type: {
            required: false,
            type: String,
            default: 'checkbox',
        },
    },
    data() {
        return {
            checkbox: false,
        };
    },
    computed: {
        labelClasses() {
            const cls = {};
            cls['text-md block font-medium leading-6 text-gray-900'] = true;
            return cls;
        },
        inputClasses() {
            const cls = {};
            cls['h-5 w-5 rounded-sm border-gray-300 text-sky-600 focus:ring-sky-600'] = true;
            return cls;
        },
    },
    created: function () {
        this.checkbox = !!this.value;
    },
};
</script>
